import React from "react"
import { BackgroundColor } from "../../components/background-color"
import { ColorInput } from "@kit/design/color-picker"
import Label from "@kit/design/label"
import PixelSlider from "@kit/design/pixel-slider"
import { useBlocks } from "app/regions/hooks/use-blocks"
import { Padding } from "app/regions/blocks/section/utils/padding"
import { BorderSettings } from "../../components/border-settings"
import { Expander } from "app/regions/blocks/shared/expander"
import { useSavedColors } from "hooks/use-saved-colors"
import { FontSettings } from "../../../header/utils/font-settings"

export function QuoteSettings({ block_id }) {
  const { properties, update } = useBlocks(block_id)

  const savedColors = useSavedColors()

  return (
    <div className="mb-4">
      <Expander label="Text">
        <FontSettings
          label="Quote font"
          fontFamilySetting="textFontFamily"
          fontWeightSetting="textFontWeight"
          properties={properties}
          update={update}
        />

        <PixelSlider
          label="Quote font size"
          name="fontSize"
          value={properties.textFontSize}
          onChange={value => update({ textFontSize: Number(value) })}
          min={8}
          max={50}
        />

        <FontSettings
          label="Name font"
          fontFamilySetting="nameFontFamily"
          fontWeightSetting="nameFontWeight"
          properties={properties}
          update={update}
        />

        <PixelSlider
          label="Name font size"
          name="fontSize"
          value={properties.nameFontSize}
          onChange={value => update({ nameFontSize: Number(value) })}
          min={8}
          max={50}
        />
      </Expander>

      <Expander label="Spacing">
        <Padding properties={properties} update={update} />
      </Expander>

      <Expander label="Colors">
        <BackgroundColor properties={properties} update={update} />

        <div>
          <Label htmlFor="textColor">Text</Label>
          <ColorInput
            id="textColor"
            name="textColor"
            onChange={color => update({ nameColor: color.hex })}
            value={properties.nameColor}
            savedColors={savedColors}
          />
        </div>
      </Expander>

      <BorderSettings properties={properties} update={update} />
    </div>
  )
}
